<div class="row step-header">
  <div class="col mb0 col-100">
    <div class="questionmark centered mb2"> </div>
    <h3>Uh-oh, something went wrong.</h3>
    <p class="mb2">We’re sorry but we’re having trouble with your request and we’d like to get this right.</p>
    <p class="mb0">You can call us directly at <a class="text-link" href="tel:+8882319403">888.231.9403</a> or email <a class="text-link" href="mailto:support@starry.com">support@starry.com</a>. Our humans are standing by.</p>
  </div>
</div>
